import { apiClient } from '@/lib/api-client'
import type {
  VacancySuggestionTokenValidationDto,
  VacancySuggestionRespondRequest,
  VacancySuggestionRespondResponse,
} from '../dto/vacancySuggestionDto'

export const validateVacancySuggestionToken = async (
  token: string,
): Promise<VacancySuggestionTokenValidationDto> => {
  const response = await apiClient.get<VacancySuggestionTokenValidationDto>(
    `/vacancy-suggestions/validate-token?token=${encodeURIComponent(token)}`,
  )
  return response.data
}

export const respondToVacancySuggestion = async (
  request: VacancySuggestionRespondRequest,
): Promise<VacancySuggestionRespondResponse> => {
  const response = await apiClient.post<VacancySuggestionRespondResponse>(
    '/vacancy-suggestions/respond',
    request,
  )
  return response.data
}
